// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#empty[data-v-22b0e2ed] {\n  margin-top: 2.2rem;\n}\n#empty img[data-v-22b0e2ed] {\n  width: 2.4rem;\n  height: 2.61333rem;\n}\n#empty p[data-v-22b0e2ed] {\n  font-weight: 500;\n  font-size: 0.37333rem;\n  color: #12033a;\n  margin-top: 0.42667rem;\n  margin-bottom: 1.33333rem;\n}\n#empty .btn[data-v-22b0e2ed] {\n  width: 8.72rem;\n}\n", ""]);
// Exports
module.exports = exports;
